// Classic text emoticons and the emoji they become. Only whole, whitespace-delimited tokens
// are converted, so URLs like https://… or times like 10:30 are left alone.
export const EMOTICONS = {
  ':)': '🙂',
  ':-)': '🙂',
  '(:': '🙂',
  ':D': '😃',
  ':-D': '😃',
  'xD': '😆',
  'XD': '😆',
  ';)': '😉',
  ';-)': '😉',
  ':(': '🙁',
  ':-(': '🙁',
  ":'(": '😢',
  ':P': '😛',
  ':-P': '😛',
  ':p': '😛',
  ':-p': '😛',
  ':O': '😮',
  ':-O': '😮',
  ':o': '😮',
  ':|': '😐',
  ':/': '😕',
  ':-/': '😕',
  ':*': '😘',
  'B)': '😎',
  '<3': '❤️',
  '</3': '💔',
  ':+1:': '👍',
  ':-1:': '👎',
};

const isBoundary = (ch) => ch === undefined || /\s/.test(ch);

/**
 * When the character just typed (before `caret`) is whitespace, converts the emoticon token
 * immediately before it. Returns the new value and caret, or null if nothing changed.
 */
export const convertTrailingEmoticon = (value, caret) => {
  if (!value || caret < 2 || !/\s/.test(value[caret - 1])) return null;
  const end = caret - 1;
  let start = end;
  while (start > 0 && !isBoundary(value[start - 1])) start -= 1;
  const token = value.slice(start, end);
  const emoji = EMOTICONS[token];
  if (!emoji) return null;
  const next = value.slice(0, start) + emoji + value.slice(end);
  return { value: next, caret: start + emoji.length + 1 };
};

/** Converts every emoticon token in the text (used when sending). */
export const convertAllEmoticons = (value) => {
  if (!value) return value;
  return value.split(/(\s+)/).map((part) => EMOTICONS[part] || part).join('');
};
